import React from 'react';
import { ICourseIcon, ICourseIconProps } from './CourseIcon';

export const BridgingIcon: ICourseIcon = React.forwardRef<SVGSVGElement, ICourseIconProps>((props, ref) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"  className={props.className}>
    <path d="M0.909668 10.1066V3.91897C2.08733 2.79084 3.87517 1.89355 6.00079 1.89355" stroke="black" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.0903 10.1066V3.91897C9.91266 2.79084 8.12485 1.89355 5.99921 1.89355" stroke="black" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M0.909668 10.1065C2.08733 8.97834 3.87517 8.08105 6.0008 8.08105" stroke="black" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.0903 10.1065C9.91266 8.97834 8.12485 8.08105 5.99921 8.08105" stroke="black" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M0.909668 6.84888C2.08733 5.72079 3.87517 4.82349 6.0008 4.82349" stroke="black" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.0903 6.84888C9.91266 5.72079 8.12485 4.82349 5.99921 4.82349" stroke="black" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>

));

BridgingIcon.displayName = 'BridgingIcon';
